'use client';

import { Plus } from 'lucide-react';
import { useState } from 'react';

const FAQ_DATA = [
  {
    question: "What's the best bird feeder for beginners?",
    answer:
      'A tube feeder with black oil sunflower seeds is perfect for beginners. It attracts a wide variety of birds including finches, chickadees, and nuthatches. Pair it with a simple platform feeder for larger birds like cardinals and blue jays.',
  },
  {
    question: 'How do I keep squirrels away from my bird feeders?',
    answer:
      'Use a squirrel baffle on your feeder pole, choose squirrel-proof feeders with weight-activated perches, or place feeders at least 10 feet from trees and structures. You can also offer squirrels their own feeding station with corn away from bird feeders.',
  },
  {
    question: 'When is the best time to watch birds?',
    answer:
      'Early morning (within 2-3 hours of sunrise) is the best time for birdwatching, as birds are most active searching for food. Late afternoon before sunset is also good. Different seasons bring different species, so year-round birding is rewarding!',
  },
  {
    question: 'What seeds attract the most birds?',
    answer:
      'Black oil sunflower seeds are the #1 choice. They attract the widest variety of birds. Nyjer (thistle) seeds are loved by goldfinches. Suet attracts woodpeckers and nuthatches. Avoid cheap mixes with filler seeds like milo that birds often ignore.',
  },
  {
    question: 'How can I identify birds in my backyard?',
    answer:
      'Start by noting size, color patterns, and behavior. Use a field guide or birding app like Merlin Bird ID. Observe beak shape (seed-eaters have short, strong beaks; insect-eaters have thin, pointed beaks). Songs and calls are also great identification clues!',
  },
];

export const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className='mx-auto max-w-[720px]'>
      {FAQ_DATA.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className='border-b border-[#e8e6e2]'
          >
            <button
              type='button'
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className='flex w-full cursor-pointer items-center justify-between gap-4 border-none bg-transparent py-6 text-left text-[18px] font-semibold text-[#1a1a1a] transition-colors hover_text-primary'
            >
              {item.question}
              <span className={`shrink-0 transition-transform ${isOpen ? 'rotate-45' : ''}`}>
                <Plus className='h-6 w-6 text-[#1a1a1a]' />
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                isOpen ? 'max-h-[400px] pb-6' : 'max-h-0'
              }`}
            >
              <p className='text-base leading-[1.7] text-[#666]'>{item.answer}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Faq;
